<template>
    <div class="monitoring-dynamics-item-column">
        <div class="monitoring-dynamics-item-column__info">
            <p class="monitoring-dynamics-item-column__name">
                Лучшая позиция товара
            </p>
            <div>
                <p class="monitoring-dynamics-item-column__value">
                    {{ data.value }}
                </p>
                <UIChanges class="changes" :value="data.changes" />
            </div>
        </div>
        <ColumnChart :active-index="5" class="monitoring-dynamics-item-column__diagram" />
    </div>
</template>

<script setup lang="ts">
    import type { MonitoringDynamicsItemColumnProps } from './types.ts'
    import ColumnChart from '~/src/shared/components/ui/charts/ColumnChart.vue'

    const props = defineProps<MonitoringDynamicsItemColumnProps>()

    const data = computed(() => {
        return {
            name: props.data.name,
            value: props.data.value,
            changes: props.data.changes
        }
    })

    // const bestPositionIndex = computed(() => {
    //     const notZero = data.value.value !== 0
    //     switch (data.value.value) {
    //         case notZero
    //     }
    // })
</script>

<style lang="scss" scoped>
    .monitoring-dynamics-item-column {
        position: relative;
        display: flex;
        justify-content: space-between;
        padding: 16px 20px;
        gap: 0 10px;

        @include respond-to(mobile) {
            padding: 12px;
        }

        &__info {
            align-self: flex-start;

            >div{
                display: flex;
                align-items: center;
                gap: 0 8px;
            }
        }

        &__value {
            font-family: var(--accent-font);
            font-size: 24px;
            font-weight: 600;
            line-height: 1;
        }

        &__name {
            margin-bottom: 8px;
            font-family: var(--accent-font);
            font-size: 12px;
            line-height: 1.2;
            color: var(--grey-400);
        }
    }
</style>
